import { store } from '../../../store/store';
import actions from '../actions';
export const hide = () => {
    store.dispatch(actions.hide());
};
